<template>
  <UiScrollArea class="max-h-[492px]">
    <TableRoot class="w-full border-spacing-y-2 [&_td]:p-2 [&_th]:px-2">
      <thead>
        <tr>
          <TableTh>No.</TableTh>
          <TableTh>Name</TableTh>
          <TableTh>Family</TableTh>
          <TableTh>Points</TableTh>
        </tr>
      </thead>
      <tbody
        class="font-Kontesa text-[15px] font-bold leading-[18px] tracking-tight 2xl:text-[18px]"
      >
        <TableTr
          v-for="user in leaderboard"
          :key="user.id"
          :class="user.highlighted ? 'bg-yellow/80' : 'bg-white/80'"
        >
          <TableTd>#{{ user.rank }}</TableTd>
          <TableTd class="w-full">
            <NuxtLink
              class="underline-offset-4 hover:underline"
              :to="
                type === 'member'
                  ? `/members/${user.name.replace(' ', '')}-${user.id}`
                  : `/partners/${user.id}`
              "
              >{{ user.name }}</NuxtLink
            ></TableTd
          >
          <TableTd>
            <div class="flex w-max items-center gap-1">
              <img class="h-5 w-5" src="~assets/images/profile/family.png" />
              {{ formatter.format(user.family) }}
            </div>
          </TableTd>
          <TableTd>
            <div class="flex w-max items-center gap-1">
              <img class="h-5 w-5" src="~assets/images/logo-icon.png" />
              {{ formatter.format(user.points) }}
            </div>
          </TableTd>
        </TableTr>
      </tbody>
    </TableRoot>
  </UiScrollArea>
</template>

<script setup lang="ts">
type LeaderboardItem = {
  id: number | string;
  rank: number;
  name: string;
  family: number;
  points: number;
  highlighted?: boolean;
};

defineProps<{
  leaderboard: LeaderboardItem[];
  type: "member" | "partner";
}>();

const formatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  notation: "compact",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});
</script>
